import React from "react";


const LoyaltyProgress = (props) => {
    const progressWidth1 =
        props.profile.summarypoints < 500
            ? `${(props.profile.summarypoints / 500) * 100}%`
            : "100%";

    const progressWidth2 =
        props.profile.summarypoints < 500
            ? "0%"
            : props.profile.summarypoints < 1500
                ? `${((props.profile.summarypoints - 500) / 1000) * 100}%`
                : "100%";
    const progressWidth3 =
        props.profile.summarypoints >= 1500
            ? "100%"
            : "0%"


    return (
        <div className="mb-[15px] w-full">
            <div className="flex flex-col w-full md:gap-4 gap-2">
                <div className="w-full flex flex-row justify-between">
                    <div className="sm:text-[20px] text-[16px] flex sm:flex-row flex-col sm:gap-2.5 gap-1">
                        <span>Ваши достижения и бонусы</span>
                        <span className={`sm:mt-0 mt-2 w-fit h-fit font-semibold rounded-[8px] bg-[#E3E3E3] px-[5px] py-[2px]`}>
                            Новичок
                        </span>
                    </div>
                    <div>
                        <a href="#"><span className="sm:text-[14px] text-[12px]">Подробнее об уровнях</span></a>
                        <hr className="mt-1" />
                    </div>
                </div>
                <div className="w-full flex flex-row justify-between h-[36px]">
                    <div className={`flex relative  bg-[#D9D9D999] w-[33%] items-center justify-center rounded-l-[8px]`}>
                        <div style={{ width: progressWidth1 }} className={`absolute left-0 rounded-l-[8px] ${props.profile.summarypoints >= 500 ? `bg-[#A6A6A6]` : `bg-[#C5C5C5]`} h-full`}>

                        </div>
                        <span className="z-10">
                            {props.profile.summarypoints > 500 ? "500 из 500" : `${props.profile.summarypoints} из 500`}
                        </span>
                    </div>
                    <div className={`flex relative bg-[#D9D9D999] w-[33%] items-center justify-center ${props.profile.summarypoints > 500 ? `text-[#1F2225]` : `text-[1F222566]`}`}>
                        <div style={{ width: progressWidth2 }} className={`absolute left-0 ${props.profile.summarypoints >= 1500 ? `bg-[#A6A6A6]` : `bg-[#C5C5C5]`} h-full`}>

                        </div>
                        <span className="z-10">
                            {props.profile.summarypoints >= 1500 ? `1500 из 1500` : `${props.profile.summarypoints} из 1500`}
                        </span>
                    </div>
                    <div className={`flex relative bg-[#D9D9D999] w-[33%] items-center justify-center rounded-r-[8px] ${props.profile.summarypoints >= 1500 ? `text-[#1F2225]` : `text-[1F222566]`}`}>
                        <div style={{ width: progressWidth3 }} className={`absolute left-0 bg-[#A6A6A6] rounded-r-[8px] h-full`}>

                        </div>
                        <span className="z-10">
                            {props.profile.summarypoints >= 1500 ? `${props.profile.summarypoints}` : `1500+`}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoyaltyProgress;
